import { generatePath } from 'react-router-dom'
import { BRAND_KITS_PATH } from 'paths'
import { Workspace } from 'types'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Brand, BrandFilled } from 'blaze-ui/icons'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Atom } from 'blaze-ui/icons/24'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuBrandKitsItem = ({ workspace, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const label = workspace.is_virtual_marketer ? 'Brand Kit' : 'Brand Kits'

  return (
    <NavMenuItem
      icon={isSystemRedesignEnabled ? Atom : Brand}
      activeIcon={isSystemRedesignEnabled ? Atom : BrandFilled}
      to={generatePath(BRAND_KITS_PATH, { workspaceId: workspace.id })}
      onPress={onPress}
      label={label}
    />
  )
}

export { NavMenuBrandKitsItem }
